module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/yandex-ok/1.png?de2cb1f7e9da92d0ac6792956a91e6f9";